export default {
    buttonRicohDirectDebitApp: 'アプリを起動',
    paragraphRicohDirectDebitDemo:
        '製品デモをご希望の場合には、下記メールアドレス宛にご連絡ください。',
    paragraphRicohDirectDebitDescription:
        '「RICOH 口座振替連携サービス for MakeLeaps」を利用すると、「MakeLeaps」に登録された請求書の請求金額と連動し、FBデータ(※)を簡単に作成出来ます。FBデータを用いた口座振替業務の効率化が可能となります。',
    paragraphRicohDirectDebitFootnote:
        '※ 口座振替データの「全銀協」フォーマットであるFB(ファームバンキング)データ',
    paragraphRicohDirectDebitForm:
        'お申込みを行う場合は、<0>口座振替連携サービス申し込みフォーム</0>に必要事項をご記入の上、送信してください。',
    paragraphRicohDirectDebitTrial:
        '購入手続きを終えていないユーザー様は、制限付きのトライアル版へアクセスいただけます。',
    subtitle: 'MakeLeapsの請求データから自動で振替データを生成できます。',
    title: 'RICOH 口座振替連携サービス for MakeLeaps',
    titleRicohDirectDebitRegistered:
        'ライセンス購入済みの方、トライアルはこちら',
};
